<template>
  <pt-adult-sell-order class="pt-adult-sell-order__withData"></pt-adult-sell-order>
</template>

<script>
import PtAdultSellOrder from './index'
export default {
  name: 'pt-adult-sell-order__withData',
  components: {
    'pt-adult-sell-order': PtAdultSellOrder
  }
}
</script>
